import { render, staticRenderFns } from "./kryptOddsInput.vue?vue&type=template&id=516aa66c&scoped=true&"
import script from "./kryptOddsInput.vue?vue&type=script&lang=js&"
export * from "./kryptOddsInput.vue?vue&type=script&lang=js&"
import style0 from "./kryptOddsInput.vue?vue&type=style&index=0&id=516aa66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516aa66c",
  null
  
)

export default component.exports